A non-negative float in the major currency unit for the ISO currency code.

For example, this is the number of dollars in dollar-denominated currencies.
